/**
 * CRM & contact-source providers for the Integrations "CRM" tab (the Sync class —
 * pull contacts in, distinct from the communication Send channels in
 * providerCatalog). Cards only here; the sync engine + field mapping live backend
 * in Right-Route-Server/service/crm. Connect is OAuth2 (wired once the per-provider
 * app credentials + connection endpoints are configured on the server).
 */
import { BRAND_NAME } from '../../theme/brand';

export const CRM_PROVIDERS = [
  {
    id: 'hubspot', name: 'HubSpot', group: 'CRM', auth: 'oauth2', recommended: true,
    tagline: `Sync HubSpot contacts into ${BRAND_NAME}`,
    logoText: 'HS', logoBg: '#ff7a59', docs: 'https://developers.hubspot.com/',
  },
  {
    id: 'salesforce', name: 'Salesforce', group: 'CRM', auth: 'oauth2',
    tagline: 'Sync Salesforce contacts & leads',
    logoText: 'SF', logoBg: '#00a1e0', docs: 'https://developer.salesforce.com/',
  },
  {
    id: 'zoho', name: 'Zoho CRM', group: 'CRM', auth: 'oauth2',
    tagline: 'Sync Zoho CRM contacts',
    logoText: 'ZO', logoBg: '#e42527', docs: 'https://www.zoho.com/crm/developer/docs/',
  },
  {
    id: 'shopify', name: 'Shopify', group: 'E-commerce', auth: 'oauth2',
    tagline: 'Sync Shopify customers as contacts',
    logoText: 'SH', logoBg: '#95bf47', docs: 'https://shopify.dev/',
  },
];

export default CRM_PROVIDERS;
